export namespace GlobalAcciones {
    export class EstablecerEsTelefono {
        static readonly type = "[Global] Establecer es telefono";
        constructor(public esTelefono: boolean) {}
    }

    export class EstablecerEsTablet {
        static readonly type = "[Global] Establecer es tablet";
        constructor(public esTablet: boolean) {}
    }

    export class Salir {
        static readonly type = "[Global] Salir";
    }
}
